import { openAPI } from "../../config";
import * as actionTypes from "./actionTypes";

export const updateCaseStudiesReviews = (URL, view, pagenumber) => {
  return (dispatch, getState) => {
    let requestURL;
    if (view !== 12) {
      requestURL = `${URL}?view=${view}&p=${pagenumber}`;
    } else {
      requestURL = `${URL}?&p=${pagenumber}`;
    }
    openAPI.get(requestURL).then(response => {
      console.log("Request URL :: ", requestURL);
      console.log("Request URL :: Response ", response);
      dispatch({
        type: actionTypes.UPDATE_VENDOR_CASESTUDIES_REVIEWS,
        payload: {
          reviews: response.data.reviews,
          pagination: response.data.pagination,
        },
      });
    });
  };
};
